import React, { useEffect } from 'react';
import { installMapGrab } from "@mapgrab/map-interface";

interface MapTestSupporterProps {
    map: maplibregl.Map | null;
    identifier?: string;
}

export const MapTestSupporter: React.FC<MapTestSupporterProps> = ({ map, identifier = "main" }) => {
    useEffect(() => {
        if (map) {
            installMapGrab(map, identifier);
        }
    }, [map, identifier]);

    return null;
}; 